export default __webpack_public_path__ + "static/media/announcement_1@3x.a6481089.png";